import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { type StudentRow } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

import { cellsFor, type StudentColumn } from './viewData.columns';

export const useAgentContext = ({
  open,
  title,
  segment,
  total,
  columns,
  rows,
}: Readonly<{
  open: boolean;
  title: string;
  segment?: string;
  total: number;
  columns: readonly StudentColumn[];
  rows: readonly StudentRow[];
}>) => {
  useRegisterAgentContext(
    open
      ? {
          kind: 'list',
          description: `Students behind the "${title}" chart${segment ? `, narrowed to ${segment}` : ''}: ${total} in total, one row per student, the visible page below.`,
          data: {
            total,
            columns: columns.map((column) => column.header),
            rows: rows.map((row) => cellsFor(columns, row)),
          },
        }
      : null,
  );
};
